import { Checkbox, FormControl, FormControlLabel, FormGroup } from '@mui/material'
import React, { useMemo } from 'react'

export const CheckboxGroupInput = ({
    disabled,
    name,
    label,
    required,
    options,
    value = [],
    onChange,
    selectAllOption,
    fullWidth,
    input
}) => {

    const handleChange = (event) => {
        const { checked, value: checkboxValue } = event.target;
        if (checked) {
            onChange(name, [...value, parseInt(checkboxValue)]);
        } else {
            onChange(name, [...value.filter(v => v !== parseInt(checkboxValue))])
        }
    }

    const selectedAll = useMemo(() => {
        return options?.filter(o => !o.disabled).every(o => value?.includes(o.value))
    }, [options, value]);

    const onSelectAll = (event) => {
        const { checked } = event.target;
        if (checked) {
            onChange(name, [...options.filter(o => !o.disabled).map(o => o.value)]);
        } else {
            onChange(name, []);
        }
    }

    return (
        <FormControl fullWidth={fullWidth} disabled={disabled} component='fieldset' variant='standard'>
            {input?.lightTitle && <label>{input?.displayName}{input?.required ? '*' : ''}</label>}
            {!input?.lightTitle && <h4 className='input-title'>{input?.displayName}{input?.required ? '*' : ''}</h4>}
            <FormGroup row sx={fullWidth ? { justifyContent: 'space-between' } : {}}>
                {options.map((option, index) => (
                    <FormControlLabel
                        key={`${label}-${option.label}-${option.value}-${index}`}
                        control={
                            <Checkbox
                                disabled={option.disabled || disabled}
                                checked={value?.includes(option.value)}
                                onChange={handleChange}
                                value={option.value}
                                name={option.label}
                            />
                        }
                        label={option.label}
                    />
                ))}
                {selectAllOption && <FormControlLabel
                    control={
                        <Checkbox checked={selectedAll} onChange={onSelectAll} name='Todos' />
                    }
                    label='Todos'
                />}
            </FormGroup>
        </FormControl>
    )
}